import type { BscDataBundle, SnapshotRow } from '../types/bsc';
import { KpiCard } from './KpiCard';

interface PerspectiveAccordionProps {
  perspective: string;
  rows: SnapshotRow[];
  bundle: BscDataBundle;
  showMoreDetails: boolean;
  showBreakdownTable: boolean;
}

export function PerspectiveAccordion({
  perspective,
  rows,
  bundle,
  showMoreDetails,
  showBreakdownTable,
}: PerspectiveAccordionProps) {
  return (
    <details className="perspective-accordion">
      <summary>
        <span>{perspective}</span>
        <span className="accordion-count">{rows.length} KPI</span>
        <span className="accordion-chevron" aria-hidden="true">⌄</span>
      </summary>
      <div className="perspective-content">
        {rows.map((row) => (
          <KpiCard
            key={row.Codice}
            row={row}
            bundle={bundle}
            showMoreDetails={showMoreDetails}
            showBreakdownTable={showBreakdownTable}
          />
        ))}
      </div>
    </details>
  );
}
